<div class="flex flex-col h-full overflow-hidden border-l border-[#d1ede3] bg-lilate-light
            transition-[width] duration-[220ms] ease-in-out"
     [class]="collapsed() ? 'w-16' : 'w-60'">

  <!-- ══════ ÉTAT OUVERT ══════ -->
  <div class="flex flex-col gap-[18px] px-5 pt-4 pb-8 flex-1 overflow-y-auto"
       [class.rc-hidden]="collapsed()">

    <!-- Header : bouton collapse + titre timer -->
    <div class="flex items-center gap-2 mb-1 shrink-0">
      <button
        class="w-7 h-7 rounded-md border border-[#d1ede3] bg-white/70 flex items-center justify-center
               cursor-pointer shrink-0 transition-colors duration-150 hover:bg-white"
        [matTooltip]="'exam-assistant-panel.collapse-tooltip' | translate"
        matTooltipPosition="left"
        (click)="collapse()">
        <svg class="w-3.5 h-3.5 text-lilate-ink-muted" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <line x1="15" y1="3" x2="15" y2="21"/>
          <polyline points="17 9 20 12 17 15"/>
        </svg>
      </button>

      @if (showTimer()) {
        <span class="font-dm-sans text-[10px] font-semibold text-lilate-dark uppercase tracking-wider"
              translate>exam-circular-timer.available-time</span>
      }
    </div>

    <!-- Timer circulaire -->
    @if (showTimer()) {
      <lib-exam-circular-timer
        [remainingSeconds]="remainingSeconds()"
        [totalSeconds]="totalSeconds()"
        [muteAlarm]="muteTimerAlarm()"
        [showLabel]="false" />
    }

    <!-- Critères d'évaluation -->
    @if (evaluationCriteria()) {
      <lib-exam-criteria-list [evaluationCriteria]="evaluationCriteria()" />
    }

    <!-- Conseil (poussé en bas avec margin-top auto) -->
    <!-- @if (advice()) {
      <lib-exam-advice-card [advice]="advice()!" />
    } -->

    <!-- Réglages périphériques + abandon (poussés en bas, icônes comme le rail) -->
    <div class="flex items-center justify-center gap-1 mt-auto pt-4 w-full border-t border-lilate-border">
      <button type="button"
        class="w-10 h-10 rounded-[9px] flex items-center justify-center cursor-pointer bg-transparent border-none
               transition-colors duration-150 hover:bg-lilate/[0.12]"
        [matTooltip]="'exam-device-settings.title' | translate"
        matTooltipPosition="left"
        (click)="openDeviceSettings.emit()">
        <mat-icon class="icon-size-5 text-lilate-dark" svgIcon="heroicons_outline:cog-6-tooth"></mat-icon>
      </button>

      @if (showAbandon()) {
      <button type="button"
        class="w-10 h-10 rounded-[9px] flex items-center justify-center cursor-pointer bg-transparent border-none
               transition-colors duration-150 hover:bg-red-500/[0.12]
               disabled:opacity-40 disabled:cursor-not-allowed"
        [matTooltip]="'ai-exam-slide.abandon-test' | translate"
        matTooltipPosition="left"
        [disabled]="abandonDisabled()"
        (click)="abandonTest.emit()">
        <svg class="w-[18px] h-[18px] text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18M6 6l12 12"/>
        </svg>
      </button>
      }
    </div>

  </div>

  <!-- ══════ ÉTAT COLLAPSÉ (RAIL) — wrapper div requis : rc-hidden ne s'applique pas au host enfant -->
  <div class="flex flex-col flex-1 min-h-0 w-full" [class.rc-hidden]="!collapsed()">
    <lib-exam-assistant-rail
      [activityLabel]="activityLabel()"
      [remainingSeconds]="remainingSeconds()"
      [totalSeconds]="totalSeconds()"
      [showTimer]="showTimer()"
      [abandonDisabled]="abandonDisabled()"
      [showAbandon]="showAbandon()"
      (expand)="expand()"
      (reformulate)="reformulate.emit()"
      (toggleTts)="toggleTts.emit()"
      (openDeviceSettings)="openDeviceSettings.emit()"
      (abandonTest)="abandonTest.emit()" />
  </div>

</div>
